//frontend/src/components/Settings.jsx

import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { FaCog, FaBell, FaLock, FaGlobe, FaPalette } from 'react-icons/fa';
import { toast } from 'react-toastify';

const Settings = () => {
    const [settings, setSettings] = useState({
        emailNotifications: true,
        pushNotifications: true,
        smsNotifications: false,
        language: 'fr',
        theme: 'light',
        autoLogout: '30',
    });

    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setSettings({
            ...settings,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Simulation de la sauvegarde
        toast.success('✅ Paramètres enregistrés avec succès');
        setMessage('Paramètres enregistrés avec succès');
        setTimeout(() => setMessage(''), 3000);
    };

    return (
        <Container className="py-4">
            <Row className="mb-4">
                <Col>
                    <h2>
                        <FaCog className="me-3" />
                        Paramètres
                    </h2>
                    <p className="text-muted">Personnalisez votre expérience E-Visa</p>
                </Col>
            </Row>

            {message && <Alert variant="success">{message}</Alert>}

            <Form onSubmit={handleSubmit}>
                {/* Notifications */}
                <Row className="mb-4">
                    <Col md={12}>
                        <Card>
                            <Card.Header>
                                <FaBell className="me-2" />
                                Notifications
                            </Card.Header>
                            <Card.Body>
                                <Form.Check
                                    type="switch"
                                    id="emailNotifications"
                                    name="emailNotifications"
                                    label="Notifications par email"
                                    checked={settings.emailNotifications}
                                    onChange={handleChange}
                                    className="mb-3"
                                />
                                <Form.Check
                                    type="switch"
                                    id="pushNotifications"
                                    name="pushNotifications"
                                    label="Notifications push"
                                    checked={settings.pushNotifications}
                                    onChange={handleChange}
                                    className="mb-3"
                                />
                                <Form.Check
                                    type="switch"
                                    id="smsNotifications"
                                    name="smsNotifications"
                                    label="Notifications SMS"
                                    checked={settings.smsNotifications}
                                    onChange={handleChange}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Langue et Région */}
                <Row className="mb-4">
                    <Col md={12}>
                        <Card>
                            <Card.Header>
                                <FaGlobe className="me-2" />
                                Langue et Région
                            </Card.Header>
                            <Card.Body>
                                <Form.Group className="mb-3">
                                    <Form.Label>Langue de l'interface</Form.Label>
                                    <Form.Select
                                        name="language"
                                        value={settings.language}
                                        onChange={handleChange}
                                    >
                                        <option value="fr">Français</option>
                                        <option value="en">English</option>
                                        <option value="es">Español</option>
                                    </Form.Select>
                                </Form.Group>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Apparence */}
                <Row className="mb-4">
                    <Col md={12}>
                        <Card>
                            <Card.Header>
                                <FaPalette className="me-2" />
                                Apparence
                            </Card.Header>
                            <Card.Body>
                                <Form.Group className="mb-3">
                                    <Form.Label>Thème</Form.Label>
                                    <Form.Select
                                        name="theme"
                                        value={settings.theme}
                                        onChange={handleChange}
                                    >
                                        <option value="light">Clair</option>
                                        <option value="dark">Sombre</option>
                                        <option value="auto">Automatique</option>
                                    </Form.Select>
                                </Form.Group>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Sécurité */}
                <Row className="mb-4">
                    <Col md={12}>
                        <Card>
                            <Card.Header>
                                <FaLock className="me-2" />
                                Sécurité
                            </Card.Header>
                            <Card.Body>
                                <Form.Group className="mb-3">
                                    <Form.Label>Déconnexion automatique (minutes)</Form.Label>
                                    <Form.Select
                                        name="autoLogout"
                                        value={settings.autoLogout}
                                        onChange={handleChange}
                                    >
                                        <option value="15">15 minutes</option>
                                        <option value="30">30 minutes</option>
                                        <option value="60">1 heure</option>
                                        <option value="never">Jamais</option>
                                    </Form.Select>
                                </Form.Group>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col className="text-end">
                        <Button type="submit" variant="primary" size="lg">
                            Enregistrer les modifications
                        </Button>
                    </Col>
                </Row>
            </Form>
        </Container>
    );
};

export default Settings;